











































































import Enumerable from "linq";
import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { MultiSelectableMixin } from "./mixins";
import MultiCustomListBoxSelector from "../../system/selectors/MultiCustomListBoxSelector.vue";

@Component({
  components: {
    MultiCustomListBoxSelector,
  },
})
export default class MultiOrderableCustomListBoxSelector extends Mixins(MultiSelectableMixin) {
  @Prop()
  selectionMaxCount: number;

  @Prop()
  additionMaxCount: number;

  @Emit()
  filteredOptionsChanged(filteredOptions: any[]): void {}

  data(): any {
    return {
      selectingOptions: [],
      selectingSelectedOptions: [],
      selectableOptions: [],
      isFilteredOptionsSelectable: false,
    };
  }
  selectingOptions: any[];
  selectingSelectedOptions: any[];
  selectableOptions: any[];
  isFilteredOptionsSelectable: boolean;

  $refs!: {
    optionList: MultiCustomListBoxSelector,
  };

  get unselectedOptions(): any[] {
    return Enumerable.from(this.options)
      .where(o => !this.contains(this.selectedOptions, o))
      .toArray();
  }

  get hasSelectingOptions(): boolean {
    return (0 < this.selectingOptions.length);
  }

  get hasSelectingSelectedOptions(): boolean {
    return (0 < this.selectingSelectedOptions.length);
  }

  get hasSelectedOptions(): boolean {
    return (0 < this.selectedOptions.length);
  }

  get isMovableToPrevious(): boolean {
    return this.isMovable(-1);
  }

  get isMovableToPost(): boolean {
    return this.isMovable(1);
  }

  get isOverSelectionMaxCount(): boolean {
    return this.selectedOptions && this.selectedOptions.length > this.selectionMaxCount;
  }

  get selectedOptionsWarning(): string {
    return this.isOverSelectionMaxCount
      ? "件数が多すぎます。" + this.selectionMaxCount + "件以下にしてください。"
      : "";
  }

  get selectedOptionsCount(): number {
    return this.selectedOptions ? this.selectedOptions.length : 0;
  }

  get selectableOptionsCount(): number {
    return this.selectableOptions ? this.selectableOptions.length : 0;
  }

  areOptionsEqual(source: any, destination: any): boolean {
    return (source === destination)
        || (source && destination && this.areEqual(source, destination));
  }

  onOptionListDblclick(event: PointerEvent): void {
    if (this.selectingOptions.length === 0 || event.target === this.$refs.optionList.$el) {
      return;
    }
    this.addSelection();
  }

  onLoadedOptionsUpdated(loadedOptions: any[]): void {
    this.isFilteredOptionsSelectable = (loadedOptions.length > 0);
  }

  onFilteredOptionsUpdated(filteredOptions: any[]): void {
    this.selectableOptions = filteredOptions;
    this.filteredOptionsChanged(filteredOptions);
  }

  addSelection(): void {
    this.selectedOptions = this.distinct(this.selectedOptions.concat(this.selectingOptions));
    this.selectingOptions = [];
  }

  addAllOptions(): void {
    if (this.additionMaxCount && (this.selectableOptionsCount > this.additionMaxCount)) {
      this.$warn("選択対象確認", "対象が多すぎます。" + this.additionMaxCount + "件以下にしてください。");
      return;
    }
    this.selectedOptions = this.distinct(this.selectedOptions.concat(this.selectableOptions));
  }

  removeSelection(): void {
    this.selectedOptions = Enumerable.from(this.selectedOptions)
      .where(o => !this.contains(this.selectingSelectedOptions, o))
      .toArray();
    this.selectingSelectedOptions = [];
  }

  removeAllOptions(): void {
    this.selectedOptions = [];
  }

  private isMovable(amount: number): boolean {
    return (this.adjustAmount(amount, this.selectingSelectedOptions, this.selectedOptions) !== 0);
  }

  moveSelection(amount: number): void {
    // 先にループを回してindexがはみ出さないようamountを調整しておく.
    const adjustedAmount = this.adjustAmount(amount, this.selectingSelectedOptions, this.selectedOptions);
    const results = this.selectedOptions.concat();
    const selecting = this.selectingSelectedOptions.concat();
    // 向きによって処理順を変える.(追い抜きによってずれるのを防ぐため.)
    Enumerable.from((0 < adjustedAmount) ? selecting.reverse() : selecting)
      .forEach(o => {
        const index = Enumerable.from(results).indexOf((s: any) => this.areOptionsEqual(s, o));
        results.splice(index, 1);
        results.splice(index + adjustedAmount, 0, o);
      });
    this.selectedOptions = results;
  }

  private adjustAmount(amount: number, selecting: any[], selected: any[]): number {
    if ((selecting.length <= 0) || (selected.length <= 0)) {
      return 0;
    }
    const indexes = Enumerable.from(selecting)
      .select(o => Enumerable.from(selected).indexOf((s: any) => this.areOptionsEqual(s, o)))
      .toArray();
    const min = Enumerable.from(indexes).min();
    const max = Enumerable.from(indexes).max();
    return ((min + amount) < 0)
      ? -min
      : ((selected.length <= (max + amount)) ? (amount - (selected.length - max)) : amount);
  }

  // linq.jsのdistinct使いたかったが、ユニークキーを返す式を指定しなくてはならないので、現状のequivalent-validatorでは対応困難.冗長だけど頑張る.
  private distinct(source: any[]): any[] {
    const results = [] as any[];
    for (const o of source) {
      if (!this.contains(results, o)) {
        results.splice(results.length, 0, o);
      }
    }
    return results;
  }

  // linq.jsのcontains使いたかったが、ユニークキーを返す式を指定しなくてはならないので、現状のequivalent-validatorでは対応困難.冗長だけど頑張る.
  private contains(options: any[], option: any): boolean {
    for (const o of options) {
      if (this.areOptionsEqual(o, option)) {
        return true;
      }
    }
    return false;
  }
}
